import React, { useState } from "react";
import { REQUEST_HANDLING_INSTRUCTIONS_MAX_LENGTH } from "./constants";

type RequestHandlingInstructionsTextareaProps = React.ComponentPropsWithoutRef<"textarea">;

export const RequestHandlingInstructionsLengthWarning = ({
  valueLength,
}: {
  valueLength: number;
}) => {
  const charactersRemaining = REQUEST_HANDLING_INSTRUCTIONS_MAX_LENGTH - valueLength;

  if (charactersRemaining > 100) {
    return null;
  }

  return (
    <p className="mt-1 text-right text-sm text-amber-600" role="status">
      {charactersRemaining > 0
        ? `${charactersRemaining} character${charactersRemaining === 1 ? "" : "s"} remaining`
        : "2,000 character limit reached"}
    </p>
  );
};

export const RequestHandlingInstructionsTextarea = ({
  defaultValue,
  onChange,
  value,
  ...props
}: RequestHandlingInstructionsTextareaProps) => {
  const [uncontrolledValueLength, setUncontrolledValueLength] = useState(
    String(defaultValue ?? "").length,
  );
  const valueLength = value === undefined ? uncontrolledValueLength : String(value).length;

  return (
    <>
      <textarea
        {...props}
        defaultValue={defaultValue}
        maxLength={REQUEST_HANDLING_INSTRUCTIONS_MAX_LENGTH}
        value={value}
        onChange={(event) => {
          setUncontrolledValueLength(event.target.value.length);
          onChange?.(event);
        }}
      />
      <RequestHandlingInstructionsLengthWarning valueLength={valueLength} />
    </>
  );
};
